import axios from '@/services/axios';

const BASE_PATH =
  '/financeiro/cobrancas/politicas';

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ''
      )
  );
}

async function listar(
  params = {}
) {
  const response =
    await axios.get(
      BASE_PATH,
      {
        params:
          cleanParams(params)
      }
    );

  const data =
    response.data;

  return {
    data:
      Array.isArray(data?.data)
        ? data.data
        : [],

    paginacao: {
      pagina:
        Number(
          data?.paginacao?.pagina ??
          1
        ),

      limite:
        Number(
          data?.paginacao?.limite ??
          20
        ),

      total_itens:
        Number(
          data?.paginacao
            ?.total_itens ??
          0
        ),

      total_paginas:
        Number(
          data?.paginacao
            ?.total_paginas ??
          0
        )
    }
  };
}

function normalizeId(id) {
  const normalizedId =
    Number(id);

  if (
    !Number.isSafeInteger(
      normalizedId
    ) ||
    normalizedId <= 0
  ) {
    throw new TypeError(
      'ID da política de cobrança inválido.'
    );
  }

  return normalizedId;
}

async function detalhar(id) {
  const normalizedId =
    normalizeId(id);

  const response =
    await axios.get(
      `${BASE_PATH}/${normalizedId}`
    );

  return response.data;
}

function normalizeExpectedToken(
  value
) {
  const token =
    String(value ?? '').trim();

  if (
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/.test(
      token
    )
  ) {
    throw new TypeError(
      'Token de concorrência da política inválido.'
    );
  }

  return token;
}

async function criar(
  dados
) {
  const response =
    await axios.post(
      BASE_PATH,
      dados
    );

  return response.data;
}

async function atualizar(
  id,
  dados,
  expectedAtualizadoEm
) {
  const normalizedId =
    normalizeId(id);

  const token =
    normalizeExpectedToken(
      expectedAtualizadoEm
    );

  const response =
    await axios.put(
      `${BASE_PATH}/${normalizedId}`,
      {
        ...dados,

        expected_atualizado_em:
          token
      }
    );

  return response.data;
}

function normalizeDateOnly(
  value
) {
  const normalized =
    String(value ?? '').trim();

  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(
      normalized
    )
  ) {
    throw new TypeError(
      'Data de vigência inválida.'
    );
  }

  return normalized;
}

async function publicar(
  id,
  expectedAtualizadoEm
) {
  const normalizedId =
    normalizeId(id);

  const token =
    normalizeExpectedToken(
      expectedAtualizadoEm
    );

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/publicar`,
      {
        expected_atualizado_em:
          token
      }
    );

  return response.data;
}

async function encerrar(
  id,
  vigenciaFim,
  expectedAtualizadoEm
) {
  const normalizedId =
    normalizeId(id);

  const normalizedVigenciaFim =
    normalizeDateOnly(
      vigenciaFim
    );

  const token =
    normalizeExpectedToken(
      expectedAtualizadoEm
    );

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/encerrar`,
      {
        vigencia_fim:
          normalizedVigenciaFim,

        expected_atualizado_em:
          token
      }
    );

  return response.data;
}

async function cancelar(
  id,
  expectedAtualizadoEm
) {
  const normalizedId =
    normalizeId(id);

  const token =
    normalizeExpectedToken(
      expectedAtualizadoEm
    );

  const response =
    await axios.post(
      `${BASE_PATH}/${normalizedId}/cancelar`,
      {
        expected_atualizado_em:
          token
      }
    );

  return response.data;
}

export const politicasCobrancasApi = {
  listar,
  detalhar,
  criar,
  atualizar,
  publicar,
  encerrar,
  cancelar
};

export default politicasCobrancasApi;
